<template>
  <div class="reset-password-box">
    <el-dialog
      title
      :visible.sync="resetPassDialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      width="380px"
      custom-class="resetpass-dailog"
      @close="entryFormInfo"
    >
      <h2 class="title tc">重置密码</h2>
      <el-tabs v-model="resetPassTabsValue">
        <el-tab-pane label="手机找回密码" name="1">
          <el-form
            :model="phoneValidate"
            ref="phoneValidate"
            :rules="rules"
            class="resetpass-form tc"
            @submit.native.prevent
          >
            <el-form-item prop="phone">
              <el-input
                v-model.trim="phoneValidate.phone"
                placeholder="请输入手机号码"
                maxlength="11"
                ref="phoneInput"
                @focus="resetPassFocus('phoneValidate', 'phone')"
                @blur="resetPassBlur('phoneValidate', 'phoneInput', 'phone')"
                @keyup.enter.native="phoneReset('phoneValidate')"
              ></el-input>
            </el-form-item>
            <div class="code-box df ai-c jc-sb imgcode-box">
              <el-form-item
                class="code-input"
                prop="phoneImgCode"
                :error="phoneImgCodeErrorMsg"
              >
                <el-input
                  v-model.trim="phoneValidate.phoneImgCode"
                  placeholder="请输入验证码"
                  maxlength="4"
                  ref="phoneImgCodeInput"
                  @focus="resetPassFocus('phoneValidate', 'phoneImgCode')"
                  @blur="
                    resetPassBlur(
                      'phoneValidate',
                      'phoneImgCodeInput',
                      'phoneImgCode'
                    )
                  "
                  @keyup.enter.native="phoneReset('phoneValidate')"
                ></el-input>
              </el-form-item>
              <img
                class="code cp"
                :src="phoneImgCaptcha"
                alt
                @click="handlePhoneImgCaptcha"
              />
            </div>
            <div class="code-box df ai-c jc-sb msgcode-box">
              <el-form-item class="code-input" prop="msgCode">
                <el-input
                  v-model.trim="phoneValidate.msgCode"
                  placeholder="请输入验证码"
                  maxlength="6"
                  ref="msgCodeInput"
                  @focus="resetPassFocus('phoneValidate', 'msgCode')"
                  @blur="
                    resetPassBlur('phoneValidate', 'msgCodeInput', 'msgCode')
                  "
                  @keyup.enter.native="phoneReset('phoneValidate')"
                ></el-input>
              </el-form-item>
              <el-button
                type="primary"
                class="code"
                :disabled="isDisabledPhoneMsg"
                @click="sendPhoneMsg"
                >{{ phoneMsgButtonName }}</el-button
              >
            </div>
            <el-form-item prop="pass" class="password-item">
              <el-input
                type="password"
                v-model.trim="phoneValidate.pass"
                autocomplete="off"
                placeholder="请输入新密码"
                maxlength="16"
                ref="phonePassInput"
                @focus="resetPassFocus('phoneValidate', 'pass')"
                @blur="resetPassBlur('phoneValidate', 'phonePassInput', 'pass')"
                @keyup.enter.native="phoneReset('phoneValidate')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phoneCheckPass" class="password-item">
              <el-input
                type="password"
                v-model.trim="phoneValidate.phoneCheckPass"
                autocomplete="off"
                placeholder="请再次输入密码"
                maxlength="16"
                ref="phoneCheckPassInput"
                @focus="resetPassFocus('phoneValidate', 'phoneCheckPass')"
                @blur="
                  resetPassBlur(
                    'phoneValidate',
                    'phoneCheckPassInput',
                    'phoneCheckPass'
                  )
                "
                @keyup.enter.native="phoneReset('phoneValidate')"
              ></el-input>
            </el-form-item>
            <el-button
              type="primary"
              class="login-btn"
              @click="phoneReset('phoneValidate')"
              :loading="phoneLoading"
              >确认提交</el-button
            >
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="邮箱找回密码" name="2">
          <el-form
            :model="emailValidate"
            ref="emailValidate"
            :rules="rules"
            class="resetpass-form tc"
            @submit.native.prevent
          >
            <el-form-item prop="email">
              <el-input
                v-model.trim="emailValidate.email"
                placeholder="请输入邮箱"
                ref="emailInput"
                @focus="resetPassFocus('emailValidate', 'email')"
                @blur="resetPassBlur('emailValidate', 'emailInput', 'email')"
                @keyup.enter.native="emailReset('emailValidate')"
              ></el-input>
            </el-form-item>
            <div class="code-box df ai-c jc-sb imgcode-box">
              <el-form-item class="code-input" prop="emailImgCode">
                <el-input
                  v-model.trim="emailValidate.emailImgCode"
                  placeholder="请输入验证码"
                  maxlength="4"
                  ref="emailImgCodeInput"
                  @focus="resetPassFocus('emailValidate', 'emailImgCode')"
                  @blur="
                    resetPassBlur(
                      'emailValidate',
                      'emailImgCodeInput',
                      'emailImgCode'
                    )
                  "
                  @keyup.enter.native="emailReset('emailValidate')"
                ></el-input>
              </el-form-item>
              <img
                class="code cp"
                :src="emailImgCaptcha"
                alt
                @click="handleEmailImgCaptcha"
              />
            </div>
            <div class="code-box df ai-c jc-sb msgcode-box">
              <el-form-item class="code-input" prop="emailCode">
                <el-input
                  v-model.trim="emailValidate.emailCode"
                  placeholder="请输入验证码"
                  maxlength="6"
                  ref="emailCodeInput"
                  @focus="resetPassFocus('emailValidate', 'emailCode')"
                  @blur="
                    resetPassBlur(
                      'emailValidate',
                      'emailCodeInput',
                      'emailCode'
                    )
                  "
                  @keyup.enter.native="emailReset('emailValidate')"
                ></el-input>
              </el-form-item>
              <el-button
                type="primary"
                class="code"
                :disabled="isDisabledEmailMsg"
                @click="sendEmailMsg"
                >{{ emailMsgButtonName }}</el-button
              >
            </div>
            <el-form-item prop="pass" class="password-item">
              <el-input
                type="password"
                v-model.trim="emailValidate.pass"
                autocomplete="off"
                placeholder="请输入新密码"
                maxlength="16"
                ref="emailPassInput"
                @focus="resetPassFocus('emailValidate', 'pass')"
                @blur="resetPassBlur('emailValidate', 'emailPassInput', 'pass')"
                @keyup.enter.native="emailReset('emailValidate')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="emailCheckPass" class="password-item">
              <el-input
                type="password"
                v-model.trim="emailValidate.emailCheckPass"
                autocomplete="off"
                placeholder="请再次输入密码"
                maxlength="16"
                ref="emailCheckPassInput"
                @focus="resetPassFocus('emailValidate', 'emailCheckPass')"
                @blur="
                  resetPassBlur(
                    'emailValidate',
                    'emailCheckPassInput',
                    'emailCheckPass'
                  )
                "
                @keyup.enter.native="emailReset('emailValidate')"
              ></el-input>
            </el-form-item>
            <el-button
              type="primary"
              class="login-btn"
              @click="emailReset('emailValidate')"
              :loading="emailLoading"
              >确认提交</el-button
            >
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { sendImgCaptcha } from "@/api/captcha";
import { sendPhoneCaptcha } from "@/api/captcha";
import { sendEmailCaptcha } from "@/api/captcha";
import { resetpass } from "@/api/resetpass";

export default {
  name: "resetPassword",
  data() {
    // 手机~确认密码的校验规则
    var validatePhoneCheckPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.phoneValidate.pass) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    // 邮箱~确认密码的校验规则
    var validateEmailCheckPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.emailValidate.pass) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };

    return {
      resetPassDialogVisible: false, //重置密码弹窗显示隐藏
      phoneLoading: false, //手机~按钮在请求接口过程的loading状态
      emailLoading: false, //邮箱~按钮在请求接口过程的loading状态
      isDisabledPhoneMsg: false, //短信验证码按钮不可点击状态
      isDisabledEmailMsg: false, //邮箱验证码按钮不可点击状态
      phoneMsgButtonName: "发送短信验证码",
      emailMsgButtonName: "发送邮箱验证码",
      phoneTime: 60, //短信验证码的倒计时60s
      emailTime: 60, //邮箱验证码的倒计时60s
      resetPassTabsValue: "1",
      tabIndex: 1,
      phoneImgCaptcha: "", //手机的图片验证码
      phoneImgCaptchaKey: "", //手机的图片验证码key值
      emailImgCaptcha: "", //邮箱的图片验证码
      emailImgCaptchaKey: "", //邮箱的图片验证码key值
      phoneImgCodeErrorMsg: null, //手机的图片验证码校验错误信息
      emailImgCodeErrorMsg: null, //手机的图片验证码校验错误信息

      phoneValidate: {
        phone: "",
        pass: "",
        phoneImgCode: "",
        msgCode: "",
        phoneCheckPass: "",
      },
      emailValidate: {
        email: "",
        emailImgCode: "",
        emailCode: "",
        pass: "",
        emailCheckPass: "",
      },
      rules: {
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            pattern:
              /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        phoneImgCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
          {
            min: 4,
            message: "验证码不正确",
            trigger: "blur",
          },
          // {
          //   validator: validatePhoneImgCode,
          //   trigger: "blur"
          // }
        ],
        emailImgCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
          {
            min: 4,
            message: "验证码不正确",
            trigger: "blur",
          },
          // {
          //   validator: validateEmailImgCode,
          //   trigger: "blur"
          // }
        ],
        msgCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        pass: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "请输入6-16位的密码",
            trigger: "blur",
          },
          {
            pattern: /^([0-9]|[a-zA-Z]|(?=[\x21-\x7e]+)[^A-Za-z0-9]){6,16}$/,
            message: "密码格式不正确",
            trigger: "blur",
          },
        ],
        phoneCheckPass: [
          {
            validator: validatePhoneCheckPass,
            trigger: "blur",
          },
        ],
        emailCheckPass: [
          {
            validator: validateEmailCheckPass,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 关闭弹窗时置空表单信息
    entryFormInfo() {
      this.$refs["phoneValidate"].resetFields();
      this.$refs["emailValidate"].resetFields();
    },
    // 清除手机发送短信验证码定时器状态
    entryPhoneTimer() {
      window.clearInterval($phoneInterval);
      this.phoneTime = 60;
      this.phoneMsgButtonName = "发送短信验证码";
      this.isDisabledPhoneMsg = false;
    },
    // 清除邮箱发送短信验证码定时器状态
    entryEmailTimer() {
      window.clearInterval($emailInterval);
      this.emailTime = 60;
      this.emailMsgButtonName = "发送邮箱验证码";
      this.isDisabledEmailMsg = false;
    },
    // 手机~图形验证码
    handlePhoneImgCaptcha() {
      sendImgCaptcha().then((response) => {
        const res = response.data;
        if (response.status) {
          this.phoneImgCaptcha = res.img;
          this.phoneImgCaptchaKey = res.key;
        }
      });
    },
    // 邮箱~图形验证码
    handleEmailImgCaptcha() {
      sendImgCaptcha().then((response) => {
        const res = response.data;
        if (response.status) {
          this.emailImgCaptcha = res.img;
          this.emailImgCaptchaKey = res.key;
        }
      });
    },

    // 发送短信验证码
    sendPhoneMsg() {
      if (!this.phoneValidate.phone) {
        this.$message({
          message: "请输入手机号码！",
          type: "warning",
        });
      } else if (!this.phoneValidate.phoneImgCode) {
        this.$message({
          message: "请输入图片验证码！",
          type: "warning",
        });
      } else {
        this.$refs["phoneValidate"].validateField(["phone"]);
        this.$refs["phoneValidate"].validateField(["phoneImgCode"]);
        let data = {
          mobile: this.phoneValidate.phone,
          ckey: this.phoneImgCaptchaKey,
          captcha: this.phoneValidate.phoneImgCode,
        };
        sendPhoneCaptcha(data)
          .then((response) => {
            console.log(response);
            const res = response.data;
          })
          .catch((error) => {
            // handle error
            console.log(error);
            this.entryPhoneTimer();
          });
        let this_ = this;
        this_.isDisabledPhoneMsg = true;
        $phoneInterval = window.setInterval(function () {
          this_.phoneMsgButtonName = this_.phoneTime + "s 后重新发送";
          --this_.phoneTime;
          if (this_.phoneTime < 0) {
            this_.phoneMsgButtonName = "发送短信验证码";
            this_.phoneTime = 60;
            this_.isDisabledPhoneMsg = false;
            window.clearInterval($phoneInterval);
          }
        }, 1000);
      }
    },
    // 发送邮箱验证码
    sendEmailMsg() {
      if (!this.emailValidate.email) {
        this.$message({
          message: "请输入邮箱！",
          type: "warning",
        });
      } else if (!this.emailValidate.emailImgCode) {
        this.$message({
          message: "请输入图片验证码！",
          type: "warning",
        });
      } else {
        this.$refs["emailValidate"].validateField(["email"]);
        this.$refs["emailValidate"].validateField(["emailImgCode"]);
        let data = {
          email: this.emailValidate.email,
          ckey: this.emailImgCaptchaKey,
          captcha: this.emailValidate.emailImgCode,
        };
        sendEmailCaptcha(data)
          .then((response) => {
            console.log(response);
            const res = response.data;
          })
          .catch((error) => {
            // handle error
            console.log(error);
            this.entryEmailTimer();
          });
        let this_ = this;
        this_.isDisabledEmailMsg = true;
        $emailInterval = window.setInterval(function () {
          this_.emailMsgButtonName = this_.emailTime + "s 后重新发送";
          --this_.emailTime;
          if (this_.emailTime < 0) {
            this_.emailMsgButtonName = "发送邮箱验证码";
            this_.emailTime = 60;
            this_.isDisabledEmailMsg = false;
            window.clearInterval($emailInterval);
          }
        }, 1000);
      }
    },

    // 手机号码重置密码
    phoneReset(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.phoneLoading = true;
          var data_ = {
            mobile: this.phoneValidate.phone,
            code: this.phoneValidate.msgCode,
            ckey: this.phoneImgCaptchaKey,
            captcha: this.phoneValidate.phoneImgCode,
            password: this.phoneValidate.pass,
            password_confirmation: this.phoneValidate.phoneCheckPass,
          };
          resetpass(data_)
            .then((response) => {
              console.log(response);
              const res = response.data;
              this.phoneLoading = false;
              this.entryPhoneTimer();
              this.entryEmailTimer();
              location.reload();
            })
            .catch((error) => {
              console.log(error);
              this.phoneLoading = false;
            });
        } else {
          this.phoneLoading = false;
          return false;
        }
      });
    },
    // 邮箱重置密码
    emailReset(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.emailLoading = true;
          var data_ = {
            email: this.emailValidate.email,
            code: this.emailValidate.emailCode,
            ckey: this.emailImgCaptchaKey,
            captcha: this.emailValidate.emailImgCode,
            password: this.emailValidate.pass,
            password_confirmation: this.emailValidate.emailCheckPass,
          };
          resetpass(data_)
            .then((response) => {
              console.log(response);
              const res = response.data;
              this.emailLoading = false;
              this.entryPhoneTimer();
              this.entryEmailTimer();
              location.reload();
            })
            .catch((error) => {
              console.log(error);
              this.emailLoading = false;
            });
        } else {
          this.phoneLoading = false;
          return false;
        }
      });
    },

    // input在focus和blur时校验的处理（focus时，不做校验，异常提示消失；blur时，当value值为空时不做校验，异常提示消失）
    resetPassFocus(_form, _prop) {
      this.$nextTick(() => {
        this.$refs[_form].clearValidate([_prop]);
      });
    },
    resetPassBlur(_form, _refItem, _prop) {
      // 3个参数：表单标识、ref值、prop值
      if (!this.$refs[_refItem].value) {
        this.$nextTick(() => {
          this.$refs[_form].clearValidate([_prop]);
        });
      }
    },
  },
  mounted: function () {
    // 打开重置密码弹窗
    eventBus.$on("showResetPassword", (opts) => {
      this.resetPassDialogVisible = true;
      this.handlePhoneImgCaptcha();
      this.handleEmailImgCaptcha();
    });
  },
};
</script>
<style lang="scss" scoped>
/deep/ .resetpass-dailog {
  color: #333;
  border-radius: 10px;
  margin: 0 !important;
  .el-dialog__header {
    padding: 0;
    .el-dialog__close {
      font-size: 16px;
      font-weight: bold;
      color: #c6c6c6;
    }
    &:hover .el-dialog__close {
      color: #409eff;
    }
    &::after {
      height: 0;
    }
  }
  .el-dialog__body {
    padding: 0 30px 32px;
    .el-tabs__header {
      margin-bottom: 28px;
    }
    .el-input__inner {
      height: 46px;
      line-height: 46px;
    }
    .el-form-item {
      margin-bottom: 24px;
    }
    .el-form-item__error {
      top: 105%;
    }
    .password-item {
      margin-bottom: 28px;
    }
    .el-button {
      height: 50px;
      line-height: 50px;
      padding: 0;
      font-size: 16px;
      border-radius: 5px;
      // background: #3b8cf7 linear-gradient(90deg, #3b8cf7 0%, #5a92ff 100%);
      background: #3b8cf7;
      &:hover {
        transition: background-color 0.5s;
        background: #1573f0;
      }
    }
    .el-button.is-disabled {
      background: #ccc;
      border-color: #ccc;
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding: 0 40px 0 35px;
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(3) {
      padding-left: 40px;
    }
    .el-tabs__active-bar {
      background-color: #3b8cf7;
    }
    .el-tabs__item.is-active,
    .el-tabs__item:hover {
      color: #3b8cf7;
    }
    .el-tabs__item.is-active {
      font-weight: bold;
    }
  }
  .title {
    font-size: 18px;
    height: 54px;
    line-height: 64px;
    color: #333;
  }
  .resetpass-form {
    .code-box {
      margin-bottom: 24px;
      .code-input {
        width: 178px;
        margin-bottom: 0;
      }
      .code {
        width: 130px;
        height: 46px;
        line-height: 46px;
        font-size: 14px;
        border-radius: 5px;
      }
    }

    .login-btn {
      width: 100%;
    }
    .forgot-btn {
      color: #666;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reset_password.vue